import "utility/validation";
import * as yup from "yup";

export default yup.object().shape({
  card: yup
    .object()
    .shape({ defaultCard: yup.mixed().nullable(), cardReady: yup.boolean() })
    .card("Card validation failed", true),
});
